import { render } from "./ReportLeave.vue?vue&type=template&id=313bf256&scoped=true"
import script from "./ReportLeave.vue?vue&type=script&lang=js"
export * from "./ReportLeave.vue?vue&type=script&lang=js"

import "./ReportLeave.vue?vue&type=style&index=0&id=313bf256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313bf256"]])

export default __exports__